// Interfaces
import { IUseBackOfficeUtilsProps } from './interfaces'

// Utils
import { routeUtils_filterRouteByRoles, routeUtils_filterRouteParent } from 'utils/common/route.utils'
import { authUtils_getUserUserAccessCodes } from 'utils/auth/auth.utils'

// Router
import { backOfficeParentRoutes, backOfficeChildrenRoutes } from 'routes/back-office'

const useBackOfficeRoutes = ({ authenticatedUser, module, optionalModule }: IUseBackOfficeUtilsProps) => {
  // Common state
  // ? when using useMemo with this state, state not behaving like you expected :(
  const parentRoutes = routeUtils_filterRouteParent(backOfficeParentRoutes, authUtils_getUserUserAccessCodes(authenticatedUser))
  const childrenRoutes = routeUtils_filterRouteByRoles(
    backOfficeChildrenRoutes.filter(backOfficeRoute => backOfficeRoute.meta.module === module && backOfficeRoute.meta.attrs?.optionalModule === optionalModule),
    authUtils_getUserUserAccessCodes(authenticatedUser),
  )

  return { parentRoutes, childrenRoutes }
}

export { useBackOfficeRoutes }
